<script>
    import { country } from '../stores.js';

    $: src = $country && $country.flag;
</script>

<div class="flag">
    {#if src}
      <h1>  {src} </h1>
    {/if}
</div>

<style>
    h1 {
		font-size:160px;
	
	}

	.flag {
		grid-column: 2 / 3;
		display: grid;
		place-items: center;
		padding: 1rem;
	}
</style>